import { styled } from '@mui/material/styles';

import { Typography } from '@mui/material';
import { renderTypographyStyles } from '../../../../../../../mui/base/utils';

export const StyledWrapperCancellationSurvey = styled('div')(
  ({ theme }) => `
    > h1 {
      margin-bottom: 0;
    }
    
    p {
      margin: ${theme.DS_spacing(['xxs'])} 0;
    }
    
    > div.MuiFormControl-root {
      > .MuiFormGroup-root {
        padding-top: 0 !important;
        padding-bottom: ${theme.DS_spacing(['xs'])} !important;
      }
    }
    
   ${theme.breakpoints.up('lg')} {
     p {
      margin: ${theme.DS_spacing(['xs'])} 0;
    }
   }
`,
);

export const StyledFormControl = styled('div')(
  ({ theme }) => `
   label > span > span > svg:last-of-type.STIGO {
        transform: scale(1.3);
   }
   
   .MuiFormControlLabel-label{
     ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
   
   }


`,
);

export const StyledRadioMessage = styled(Typography)(
  ({ theme }) => `
 margin: 0 !important;
  > span:first-of-type {
    color: ${theme.DS_palette.buttons.enabled};
  }

`,
);
